var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailVerification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 154,
    height: 151,
    viewBox: "0 0 154 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M134.95 38.8C137.214 38.8 139.05 36.9643 139.05 34.7C139.05 32.4356 137.214 30.6 134.95 30.6C132.685 30.6 130.85 32.4356 130.85 34.7C130.85 36.9643 132.685 38.8 134.95 38.8Z",
    fill: "#E4DAFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M130.85 25.5C132.396 25.5 133.65 24.2464 133.65 22.7C133.65 21.1536 132.396 19.9 130.85 19.9C129.303 19.9 128.05 21.1536 128.05 22.7C128.05 24.2464 129.303 25.5 130.85 25.5Z",
    fill: "#E4DAFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4499 34.7C18.9963 34.7 20.2499 33.4464 20.2499 31.9C20.2499 30.3536 18.9963 29.1 17.4499 29.1C15.9035 29.1 14.6499 30.3536 14.6499 31.9C14.6499 33.4464 15.9035 34.7 17.4499 34.7Z",
    fill: "#E4DAFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.15 96.3C14.0218 96.3 16.35 93.9719 16.35 91.1C16.35 88.2281 14.0218 85.9 11.15 85.9C8.27807 85.9 5.94995 88.2281 5.94995 91.1C5.94995 93.9719 8.27807 96.3 11.15 96.3Z",
    fill: "#E4DAFC"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6765_50504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M131.793 52.393V106.534C131.793 106.757 131.793 106.869 131.793 107.092C131.681 110.217 130.23 112.897 127.997 114.794C126.1 116.469 123.532 117.585 120.741 117.585H33.335C31.4373 117.585 29.6512 117.139 28.0883 116.245C27.4186 115.911 26.7488 115.464 26.1906 114.906C24.9627 113.901 23.8464 112.45 23.2882 110.887C22.8417 109.771 22.5068 108.543 22.5068 107.315V52.393C22.5068 52.393 27.0837 48.486 33.6699 43.1277C40.4793 37.4346 49.4097 30.067 57.2238 23.5924C61.689 19.797 61.2425 20.2435 68.1636 14.4387C73.4102 9.97354 81.1127 9.97354 86.3593 14.4387C87.6989 15.5551 89.1501 16.8946 90.4896 18.0109C93.392 20.3552 96.5177 23.0343 99.8666 25.825C106.899 31.6298 114.602 38.1044 120.63 43.1277C126.769 48.1511 131.235 51.9465 131.793 52.393Z",
    fill: "url(#paint0_linear_6765_50504)"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120.63 43.0161V62.4397L101.541 73.9376L95.8478 77.3982L83.7917 84.6541L78.0986 88.1147L75.6427 89.5659L73.2985 88.1147L67.9403 84.6541L56.4424 77.3982L51.0841 73.9376L33.4465 62.8862V43.1277C40.256 37.4346 49.1864 30.067 57.0005 23.5924L99.7549 25.7134C106.899 31.6298 114.602 37.9927 120.63 43.0161Z",
    fill: "#989FB0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M116.834 27.6111V61.7699L99.4199 72.1516L94.2849 75.2772L83.2335 81.7518L78.0985 84.8774L75.8659 86.1053L73.745 84.8774L68.8332 81.7518L58.34 75.2772L53.4283 72.1516L37.3535 62.1048V27.6111C37.3535 24.0389 40.2559 21.1365 43.9397 21.1365H110.248C113.82 21.0249 116.834 24.0389 116.834 27.6111Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M22.9534 52.1698L75.4196 55.6303L131.011 52.1698L128.89 62.1049C128.89 62.1049 76.6475 89.3427 76.9824 89.3427C77.3173 89.3427 23.065 57.0815 23.065 57.0815L22.9534 52.1698Z",
    fill: "url(#paint1_linear_6765_50504)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M131.793 52.3931V107.092C131.681 110.218 130.23 112.897 127.997 114.794C126.1 116.469 123.532 117.585 120.741 117.585H33.335C31.4373 117.585 29.6512 117.139 28.0883 116.246C27.4186 115.911 26.7488 115.464 26.1906 114.906C24.9627 113.901 23.8464 112.45 23.2882 110.887C22.8417 109.771 22.5068 108.543 22.5068 107.315V107.203V52.3931L71.4009 82.9797L75.6428 85.6589L77.094 84.7658L78.4336 83.9844L131.793 52.3931Z",
    fill: "#916CF1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M128.109 114.794C126.211 116.469 123.644 117.585 120.853 117.585H33.335C31.4373 117.585 29.6512 117.139 28.0883 116.246C27.4186 115.911 26.7488 115.464 26.1906 114.906C24.9627 113.901 23.8464 112.45 23.2882 110.887C22.8417 109.771 22.5068 108.543 22.5068 107.315V107.203V52.3931L28.2 55.8536L77.094 84.7658L78.4336 85.5472L78.5452 85.6589L122.416 111.557L128.109 114.794Z",
    fill: "url(#paint2_linear_6765_50504)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M78.4336 83.8727V87.6682L28.0884 116.245C27.4186 115.911 26.7489 115.464 26.1907 114.906C24.9628 113.901 23.8465 112.45 23.2883 110.887L72.294 81.8634L76.5359 84.5425L77.0941 84.7658L78.4336 83.8727Z",
    fill: "url(#paint3_linear_6765_50504)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5068 52.3931L77.094 84.7658",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M131.793 52.3931V107.092C131.681 110.218 130.23 112.897 127.997 114.794C126.1 116.469 123.532 117.585 120.741 117.585H33.335C31.4373 117.585 29.6512 117.139 28.0884 116.246C27.4186 115.911 26.7488 115.464 26.1907 114.906L31.7722 111.557L75.6429 85.6589L77.094 84.7658L78.4336 83.9844L125.988 55.742L131.793 52.3931Z",
    fill: "#916CF1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M131.793 52.3931L78.4336 83.8728L77.094 84.7658L75.6429 85.6589L26.1907 114.794",
    fill: "#916CF1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M131.793 52.3931L78.4336 83.8728L77.094 84.7658L75.6429 85.6589L26.1907 114.794",
    stroke: "white",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M118.62 90.6822H89.5966C88.9268 90.6822 88.3687 90.124 88.3687 89.4542C88.3687 88.7845 88.9268 88.2263 89.5966 88.2263H118.62C119.29 88.2263 119.848 88.7845 119.848 89.4542C119.96 90.124 119.402 90.6822 118.62 90.6822Z",
    fill: "#E4DAFC"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M118.62 99.0544H89.5966C88.9268 99.0544 88.3687 98.4962 88.3687 97.8264C88.3687 97.1567 88.9268 96.5985 89.5966 96.5985H118.62C119.29 96.5985 119.848 97.1567 119.848 97.8264C119.96 98.4962 119.402 99.0544 118.62 99.0544Z",
    fill: "#E4DAFC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M124.648 116.469L128.221 114.683C128.109 114.794 128.109 114.794 127.997 114.906C127.997 114.906 127.997 114.906 127.886 114.906L124.648 116.469Z",
    fill: "#7647EE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9398 55.8414L74.3 56.2165L74.6606 55.8418L95.6288 34.0606L95.6292 34.0602C96.7048 32.9402 98.5146 32.9402 99.5901 34.0602C100.677 35.1915 100.677 37.1115 99.5904 38.2429C99.5903 38.243 99.5902 38.2431 99.5901 38.2431L76.2813 62.4617L76.2742 62.4691L76.2674 62.4768C75.766 63.0424 75.0459 63.3154 74.3004 63.3154C73.5675 63.3154 72.8846 63.0502 72.3199 62.4621L61.0725 50.7501C59.9859 49.6187 59.9859 47.6986 61.0725 46.5672C62.148 45.4472 63.9578 45.4472 65.0334 46.5672L73.9398 55.8414Z",
    fill: "#7647EE",
    stroke: "#916CF1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6765_50504",
    x: 0.506836,
    y: 0.0898438,
    width: 153.286,
    height: 150.495,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6765_50504"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6765_50504",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6765_50504",
    x1: 77.1061,
    y1: 12.3382,
    x2: 77.1061,
    y2: 91.8291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6765_50504",
    x1: 76.9344,
    y1: 101.128,
    x2: 76.9344,
    y2: 54.6748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A90B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7AED2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6765_50504",
    x1: 75.2735,
    y1: 50.8851,
    x2: 75.2735,
    y2: 118.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6765_50504",
    x1: 54.01,
    y1: 102.203,
    x2: 49.7295,
    y2: 95.9381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D8E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E4F0",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailVerification);
export default __webpack_public_path__ + "static/media/email-verification.36164137be7bf4df0ba64a49491daec8.svg";
export { ForwardRef as ReactComponent };